export default [
  {
    path: '/active-newyear2023/index',
    name: 'index',
    component: () => import('@/views/active-newyear2023/index'),
    meta: {
      title: '2023新年狂欢，盲盒抽不停-高考直通车'
    }
  },
]
